import _ from 'lodash'
import { FETCH_EXTERNAL_ACCOUNTS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_EXTERNAL_ACCOUNTS:
      return action.payload
    default:
      return state
  }
}
